module.exports = __webpack_public_path__ + "static/media/sweIconHeadOut.007525eb.png";